export function isTemporaryChatError(error) {
  return ['unavailable', 'deadline-exceeded', 'internal', 'resource-exhausted', 'network-request-failed']
    .includes(String(error?.code || '').replace(/^functions\//, ''));
}
